import React from 'react'
import Navbar from '../components/Navbar'
import Hero from '../components/Hero'
import Footer from '../components/Footer'
import WhyItMatters from './sections/WhyItMatters'
import OurApproach from './sections/OurApproach'
import GetInvolvedSection from './sections/GetInvolvedSection'
import CTA from '../components/CTA'

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        {/* Full-viewport hero + stats bar */}
        <Hero />

        {/* Mission statement */}
        <section className="mission-section">
          <div className="container">
            <span className="mission-quote-mark" aria-hidden="true">&ldquo;</span>
            <p className="mission-text fade-in">
              We believe every child deserves the chance to learn, play, and grow —
              and that football and education, combined with purpose, can transform lives.
            </p>
            <div className="mission-divider"></div>
          </div>
        </section>

        {/* Why This Matters */}
        <WhyItMatters />

        {/* Our Approach */}
        <OurApproach fadeClass="fade-in" />

        {/* Get Involved */}
        <GetInvolvedSection fadeClass="fade-in" />

        {/* Final CTA */}
        <CTA fadeClass="fade-in" />
      </main>
      <Footer />
    </>
  )
}
